const steps = [
  {
    number: "01",
    icon: "ri-search-eye-line",
    title: "Diagnostic Assessment",
    description: "We evaluate your system's performance, identify faults, and assess your energy goals before recommending anything.",
  },
  {
    number: "02",
    icon: "ri-draft-line",
    title: "Tailored Solution",
    description: "Repair plan, battery sizing, or electrical scope — designed specifically for your property. No upsells, no guesswork.",
  },
  {
    number: "03",
    icon: "ri-hammer-line",
    title: "Expert Execution",
    description: "Licensed professionals. Code-compliant work. Clean installs and repairs that hold up for years.",
  },
  {
    number: "04",
    icon: "ri-line-chart-line",
    title: "Verified Performance",
    description: "System testing, monitoring setup, and performance confirmation so you know it's working at full capacity.",
  },
];

export default function Process() {
  return (
    <section className="py-24 md:py-32 bg-stone-50">
      <div className="max-w-7xl mx-auto px-4 md:px-8">

        {/* Header */}
        <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-6 mb-16">
          <div className="max-w-xl">
            <span className="text-amber-500 text-xs font-bold tracking-[0.2em] uppercase">How It Works</span>
            <h2
              className="text-4xl md:text-5xl font-black text-gray-950 mt-3 leading-tight tracking-tight"
              style={{ fontFamily: "'Syne', sans-serif" }}
            >
              From First Call to<br />Full Performance
            </h2>
          </div>
          <p className="text-gray-500 text-sm leading-relaxed max-w-xs md:text-right">
            A clear, professional process — no surprises, no delays. Just results.
          </p>
        </div>

        {/* Steps grid */}
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-px bg-gray-200 rounded-2xl overflow-hidden">
          {steps.map((step, index) => (
            <div
              key={step.number}
              className="bg-white p-8 md:p-10 group hover:bg-amber-50 transition-colors duration-300 relative"
            >
              <div
                className="text-[80px] font-black leading-none text-gray-100 group-hover:text-amber-100 transition-colors select-none mb-4"
                style={{ fontFamily: "'Syne', sans-serif" }}
              >
                {step.number}
              </div>
              <div className="w-10 h-10 flex items-center justify-center bg-amber-50 group-hover:bg-amber-100 rounded-xl mb-5 transition-colors border border-amber-100">
                <i className={`${step.icon} text-amber-500 text-lg`}></i>
              </div>
              <h3
                className="text-base font-black text-gray-900 mb-3 tracking-tight"
                style={{ fontFamily: "'Syne', sans-serif" }}
              >
                {step.title}
              </h3>
              <p className="text-gray-500 text-sm leading-relaxed">{step.description}</p>

              {index < steps.length - 1 && (
                <div className="hidden lg:flex absolute top-10 -right-3 z-10 w-6 h-6 items-center justify-center bg-white rounded-full border border-gray-200">
                  <i className="ri-arrow-right-s-line text-amber-400 text-sm"></i>
                </div>
              )}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
